import { AppData, Log } from '@lightningjs/sdk'
import { AppSetup } from './app-setup'
import { Config } from './config'
import { REQUEST_STATUS } from './enum'
import { Helper } from './helper'
import RowList from './components/grid/row-model'
import { ItemNode } from './components/grid/ItemNode'

export const parseSubCategories = function (data: any) {
  //logger.printLog('data', 'parseSubCategories() data: ', data)
  let list: RowList[] = []
  const channels = data.channels
  if (channels !== undefined) {
    channels.map(function (channel: any, index: any) {
      // if (channel && channel.url.indexOf('getQueuelist.php') > -1) {
      //   rowList = app.queueManager.getQueueList()
      //   rowList.name = channel.name
      // } else {

      // if (
      //   rowList.rowstyle &&
      //   config.appConfig.enableMixedGrid &&
      //   !helper.getIptvParameterFromUrl('gridstyle', rowList.url)
      // ) {
      //   rowList.url += '&gridstyle=' + rowList.rowstyle
      // }
      //}
      if (!isFilteredRow(channel)) {
        const rowList = new RowList(channel, index)
        list.push(rowList)
      }
    })
  } else if (data.results) {
    list = parseSubChannelsViaResults(data)
  }
  return list
}

export const parseSubChannels = (data: any): RowList[] => {
  Log.info('Parser:', 'parseSubChannels() data: ', data)
  let subChannelsList: RowList[] = []
  if (data.channels !== undefined) {
    let index = 0;
    for (const channel in data.channels) {
      const val = data.channels[channel]
      const channelsList: any = {}
      channelsList.name = val.title
      channelsList.description = val.description
      channelsList.title = val.title
      channelsList.url = val.feed
      //channelsList.image 		= val.image
      channelsList.feed_type = Helper.getFeedType(val.feed_type)
      channelsList.actiontype = val.actiontype
      channelsList.actionkey = val.actionkey
      channelsList.row_type = val.row_type
      channelsList.season = val.season_no || val.season
      if (val.rowstyle) {
        channelsList.rowstyle = val.rowstyle
        channelsList.row_height = val.row_height
        channelsList.row_item_height = val.row_item_height
        channelsList.row_item_width = val.row_item_width
      }
      if (!isFilteredRow(channelsList)) {
        const rowList = new RowList(channelsList, index)
        subChannelsList.push(rowList)
      }
      index++
    }
    //})
  } else if (data.results) {
    subChannelsList = parseSubChannelsViaResults(data)
  }
  return subChannelsList
}

/* Below method is created to keep it separate from above parseSubChannels method
  - used in case when API returns "results" format data instead of "channels" format data
*/
export const parseSubChannelsViaResults = function (data: any): RowList[] {
  //logger.printLog('data', 'parseSubChannelsViaResults() data: ', data)
  const subChannelsList: RowList[] = []
  if (data.results !== undefined) {
    for (const channel in data.results) {
      const val = data.results[channel]
      //if (val.title !== 'Live') {
        const channelsList: any = {}
        channelsList.id = val.id
        channelsList.name = val.title
        channelsList.description = val.description
        channelsList.title = val.title || ''
        channelsList.url = val.url
        channelsList.feed_type = Helper.getFeedType(val.feed_type)
        channelsList.actiontype = val.actiontype
        channelsList.actionkey = val.actionkey
        channelsList.season = (val.season_no || val.season)
        channelsList.initFetcingStatus = REQUEST_STATUS.NONE
        if (val.rowstyle) {
            channelsList.rowstyle = val.rowstyle
            channelsList.row_height = val.row_height
            channelsList.row_item_height = val.row_item_height
            channelsList.row_item_width = val.row_item_width
        } else {
            const rowStyle = Helper.getRowStyle()
            channelsList.rowstyle = rowStyle.rowstyle
            channelsList.row_height = rowStyle.row_height
            channelsList.row_item_height = rowStyle.row_item_height
            channelsList.row_item_width = rowStyle.row_item_width
        }


        const rowList = new RowList(channelsList)
        subChannelsList.push(rowList)
      //}
    }
  }
  return subChannelsList
}

export const parseChannels = function (data: any): ItemNode[] {
  const { appState } = AppData as AppSetup
  const app = appState?.getApp()
  const videos: ItemNode[] = []
  if (data.channels !== undefined) {
    for (const channel in data.channels) {
      const val = data.channels[channel]
      if (app?.siteId !== val.site_id) {
        const video: any = {}
        video.title = val.title
        video.description = val.description
        video.type = Helper.getFeedType(val.feed_type)
        video.feed_type = val.feed_type
        video.feed = val.feed
        video.season = val.season_no || val.season
        video.main_picture = val.hd_image //(isPortrait ? val.bg_image_portrait : val.bg_image_landscape);
        video.plugin_id = val.plugin_id
        video.apple_id = val.apple_id
        video.site_id = val.site_id
        video.url = val.url
        const nodeItem: ItemNode = Object.assign(new ItemNode(), video)
        videos.push(nodeItem)
      }
    }
  }
  return videos
}

export const parseVideos = function (data: any): ItemNode[] {
  const videos: ItemNode[] = []
  if (data.results !== undefined) {
    for (const node in data.results) {
      const val = data.results[node]
      /*if (val.title == 'Live') {
        //temporary for testing in 427
        return videos
      }*/
      const item: any = {}
      item.id = val.id
      item.title = val.title
      item.description = val.description
      item.type = val.type
      item.feed_type = Helper.getFeedType(val.feed_type)
      item.actiontype = val.actiontype
      item.author = val.author
      item.updated = val.updated
      item.date = val.date
      item.uid = val.uid
      item.main_picture = val.main_picture
      item.bg_image_landscape = val.bg_image_landscape
      item.hero_image=val.hero_image
      item.like_count = val.like_count
      item.video_url = val.video_url
      item.video_hls_url = val.video_hls_url
      item.drm = val.drm || null
      item.video_format = val.video_format
      item.node_id = val.node_id
      item.runtime = Helper.toNumber(val.runtime, 0)
      item.release_date = Helper.getYearFrom(val.release_date)
      item.age_appropriate_rating = val.age_appropriate_rating
      /** Changes for XFIN-977 Comcast | AVOD - Add new macros - 2 */
      item.age_group = val.age_group      
      item.gender = val.gender
      item.brands = val.brands
      item.content_language = val.content_language
      /** Changes for XFIN-977 Comcast | AVOD - Add new macros - 2 */
      item.popularity_rating = Helper.toNumber(val.popularity_rating, -1)
      item.author = val.author
      item.actors = (val.actors && val.actors instanceof Array)?val.actors:[]
      item.directors = (val.directors && val.directors instanceof Array)?val.directors:[]
      item.ad_breaks = val.ad_breaks
      item.primary_category = val.primary_category
      item.series_name = val.series_name
      item.season = val.season
      item.episode = val.episode
      item.bookmark_feed = !val.bookmark_feed ? '' : val.bookmark_feed
      item.content_genre = val.content_genre
      item.primary_genre = val.primary_genre;
      if(val.epg_type && val.epg_url ) {
        item.epg_type = val.epg_type
        item.epg_url = val.epg_url
      }
      item.cc_path = val.cc_path
      item.actionkey = val.actionkey
      item.catId = val.catId
      item.subCatId = val.subCatId
      item.url = val.url
      item.blockItem = Helper.toBoolean(val.blockItem)
      item.deeplink_url = val.deeplink_url ? val.deeplink_url : ''
      item.intro_st = val.intro_st ? val.intro_st : 0
      item.intro_et = val.intro_et ? val.intro_et : 0
      item.endcredit_st = val.endcredit_st ? val.endcredit_st : 0
      item.endcredit_et = val.endcredit_et ? val.endcredit_et : 0
      item.menudisplay_st = val.runtime ? Helper.toNumber(val.runtime, 0) - 10 : 0
      const nodeItem: ItemNode = Object.assign(new ItemNode(), item)
      videos.push(nodeItem)
    }
  }
  return videos
}

export const isFilteredRow = (channel: any): boolean => {
  const { appConfig } = AppData as AppSetup
  const name: string = channel?.name
  const row_type: string = channel?.row_type
  //console.log('row_type ',row_type);
  if (appConfig?.enableSuggestedChannels == false &&
    (
      name.toLowerCase() == 'suggested channels' ||
      row_type == 'app-suggestions'
    )) {
    return true
  }
  if (appConfig?.enableQueueManagement == false && name.toLowerCase() == 'queue') {
    return true
  }
  if (appConfig?.enableLiveRow == false && row_type == 'live') {
    return true
  }
  /* Fix for IPTV-2225 */
  if (appConfig?.disableGeneralRow == true && row_type == 'general') {
    return true
  }
  /* Fix for IPTV-2225 */
  return false
}
